import { render, staticRenderFns } from "./ExtratoMovimentacaoServico.vue?vue&type=template&id=99cae654"
import script from "./ExtratoMovimentacaoServico.vue?vue&type=script&lang=js"
export * from "./ExtratoMovimentacaoServico.vue?vue&type=script&lang=js"
import style0 from "./ExtratoMovimentacaoServico.vue?vue&type=style&index=0&id=99cae654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports